import { IRON_RED_LUT } from './ironRedLut';

/**
 * DJI Iron Red 팔레트 (palette_iron_red_bar.png → 256 LUT).
 *
 * 절차:
 *   u = clamp((T - lo) / (hi - lo), 0, 1)
 *   i = round(u * 255)
 *   RGB = IronRedLUT[i]
 */

/**
 * @param {number} u 0..1
 * @param {number} [alpha=200] 0..255
 * @returns {[number, number, number, number]}
 */
export function ironRedRgba(u, alpha = 200) {
  const t = Math.max(0, Math.min(1, Number(u) || 0));
  const a = Math.max(0, Math.min(255, Math.round(alpha)));
  const i = Math.round(t * 255);
  const idx = i * 3;
  return [IRON_RED_LUT[idx], IRON_RED_LUT[idx + 1], IRON_RED_LUT[idx + 2], a];
}

/** @deprecated ironRedRgba 와 동일 */
export function ironbowRgba(u, alpha = 200) {
  return ironRedRgba(u, alpha);
}

/**
 * @param {number} temp T[y][x] °C
 * @param {number} lo 상대 하한
 * @param {number} hi 상대 상한
 * @param {number} [alpha]
 */
export function temperatureToRgba(temp, lo, hi, alpha = 200) {
  const low = Number(lo);
  const high = Number(hi);
  const v = Number(temp);
  if (![low, high, v].every(Number.isFinite)) {
    return [0, 0, 0, 0];
  }
  let u = high === low ? 0.5 : (v - low) / (high - low);
  u = Math.max(0, Math.min(1, u));
  return ironRedRgba(u, alpha);
}
